export const headerHeight = 80;
export const jumbotronHeight = 380;
